import ContentComponentWithoutDnD from './ContentComponentWithoutDnD';
import { ContentComponentWithDnDCompat } from './ContentComponentWithDndCompat';
import { jsx as _jsx } from "react/jsx-runtime";
export const getContentComponent = ({
  column: {
    columnNamespace,
    columnName,
    resizable,
    reorderable
  },
  originalWidth,
  columnIndex,
  isLastColumn,
  handleResize,
  onResizeEnd,
  onColumnOrderChange
}) => {
  const ContentComponent = resizable || reorderable ? ContentComponentWithDnDCompat : ContentComponentWithoutDnD;
  return props => /*#__PURE__*/_jsx(ContentComponent, Object.assign({}, props, {
    // These props are required for the DnD wrapper to function
    columnNamespace: columnNamespace,
    columnName: columnName,
    columnIndex: columnIndex,
    onColumnOrderChange: onColumnOrderChange,
    isLastColumn: isLastColumn,
    handleResize: handleResize,
    onResizeEnd: onResizeEnd,
    originalWidth: originalWidth,
    reorderable: reorderable,
    resizable: resizable
  }));
};